import React from 'react'
import {Highlights} from "./content";
import {AccordianSection} from "./accordian-section";


export const Timeline=( {timelineContent})=>{

    return <div className='timeline-container'>
        <div className='timeline-container-line'>
            {timelineContent.length!==0&&timelineContent.map(el=><div className="timeline-event-start">
            <div className="timeline-event-section">
            <div className='timeline-heading'>{el.heading}</div>
                <div className='timeline-subheading'>{el.subHeading1}</div>
                <div className='timeline-content'>{el.subHeading2}</div>
                <div className='timeline-content'>{el.description}</div>
                {el.contents.length!==0&&<div className='timeline-content'><AccordianSection heading="Summary" component=<Highlights {...el}/>/></div>}


            </div>
            </div>)}
        </div>

    </div>

}